<li data-toggle="collapse" data-target=".nav-collapse">
    <a (click)="click()">{{title}}</a>
    <ng-content></ng-content>
</li>
